import {createNamespacedHelpers} from 'vuex';
import {NOT_STARTED} from "../Constants";
import {_} from "vue-underscore";

const {mapGetters, mapActions} = createNamespacedHelpers('student/course');

export const LessonProgressMixin = {
  computed: {
    ...mapGetters({
      getLessonProgress: 'getLessonProgress',
      learningIsStarted: 'learningIsStarted'
    }),
    nextLessonIsAble() {
      return this.getNextLessonId() !== -1
    },
    getNextLessonId() {
      return this.$store.getters['student/course/getNextLessonId'](this.currentLessonId)
    },
    courseProgress() {
      return this.$store.getters['student/course/getCourseProgress']
    },
    lessonProgress() {
      return _.find(this.courseProgress, item => item.lessonId === this.currentLessonId)
    },
    currentLessonId() {
      return this.$route.params.lessonId
    },
  },
  methods: {
    ...mapActions({
      createCourseProgress: 'createCourseProgress',
      loadProgress: 'loadCourseProgress'
    }),
    async createProgress(lessonId) {
      if (!this.hasProgress(lessonId)) {
        const form = {lessonId}
        await this.createCourseProgress(
          {urlParams: this.$route.params, form}
        )
      }
    },
    async makeLessonDone(progressId) {
      await this.$store.dispatch(
        'student/course/lesson/makeDone',
        {urlParams: {...this.$route.params, progressId}}
        );
    },

    async goToLesson(lessonId) {
      await this.$router.push({
        name: 'learn-lesson-page',
        params: {...this.$route.params, lessonId}
      })
    },

    async continueLearning() {
      const lessonId = this.getNextLessonId
      if (lessonId && lessonId >= 0) {
        await this.learnLesson(lessonId);
      } else {
        await this.goToCourseContent()
      }
    },

    async goToCourseContent() {
      const routeName = "learn-course-content";
      if (this.$route.name !== routeName) {
        await this.$router.push({
          name: routeName,
          params: {...this.$route.params}
        });
      }
    },

    async learnLesson(lessonId) {
      await this.createProgress(lessonId);
      await this.loadProgress({urlParams: this.$route.params});
      await this.goToLesson(lessonId);
    },

    hasProgress(lessonId) {
      return this.getLessonProgress(lessonId) !== NOT_STARTED
    },
  }
}
